module.exports = __webpack_public_path__ + "img/vector.334b871.png";